<template>
  <div class="passoRegistro">
    <div class="passoRegistro_header">
      <h3 class="passoRegistro_header_title">
        Registrador
      </h3>
    </div>

    <div class="px-2 pt-2 mb-4"
         name="formAddRegistrador">
      <div class="row">
        <div class="col-sm-5">
          <label
            class="label"
            for="falecido_digitador_nome">Nome do Digitador</label>
          <select
            id="falecido_digitador_nome"
            v-model="localData.digitador"
            class="custom-select custom-select-sm"
            name="digitador"
            :disabled="!digitadores.length"
            @change="changed">
            <option v-if="!digitadores.length"
                    value="">
              Não existem digitadores
            </option>
            <option v-for="(usuario, index) in digitadores"
                    :key="index"
                    :value="usuario.nome">
              {{ usuario.nome }}
            </option>
          </select>
        </div>

        <div class="col-sm-4">
          <label
            class="label"
            for="escrevente">Escrevente</label>
          <select
            id="escrevente"
            v-model="localData.escrevente"
            class="custom-select custom-select-sm"
            name="escrevente"
            :disabled="!escreventes.length"
            @change="changeEscrevente()">
            <option v-if="!escreventes.length"
                    value="">
              Não existem escreventes
            </option>
            <option v-for="(escrevente, index) in escreventes"
                    :key="index"
                    :value="escrevente.nome">
              {{ escrevente.nome }}
            </option>
          </select>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label
              class="label"
              for="data_registro">Data do Registro</label>
            <input
              id="data_registro"
              v-model="localData.data_registro"
              v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
              required
              class="form-control form-control-sm"
              name="data_registro"
              :class="{ 'is-invalid': errors.has('data_registro') }"
              placeholder="09/08/2019"
              type="date"
              @change="validateInputs('data_registro')">
            <small v-if="errors.has('data_registro')"
                   class="invalid-feedback">{{ errors.first('data_registro') }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="passoRegistro_header">
      <h3 class="passoRegistro_header_title">
        Registro
      </h3>
    </div>

    <form class="px-2 pt-2"
          name="formAddRegistro">
      <div v-if="!legado"
           class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for=""
                   class="label d-block">1ª via ou Legado <span class="text-danger"> * </span></label>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="primeiraViaRegistro"
                v-model="localData.origem"
                v-validate="{ required: true}"
                class="custom-control-input"
                checked
                name="primeiraViaRegistro"
                type="radio"
                value="novo"
                :class="{'is-invalid': errors.has('registro')}"
                @change="changed"
                @keyup.enter="localData.origem = 'novo'">
              <label
                class="custom-control-label"
                for="primeiraViaRegistro">1ª via</label>
            </span>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="legadoRegistro"
                v-model="localData.origem"
                v-validate="{ required: true}"
                class="custom-control-input"
                name="legadoRegistro"
                value="legado"
                :class="{'is-invalid': errors.has('registro')}"
                type="radio"
                @change="reset"
                @keyup.enter="localData.origem = 'legado'">
              <label
                class="custom-control-label"
                for="legadoRegistro">Legado</label>
            </span>
          </div>
        </div>
      </div>

      <div v-if="localData.origem=='legado'"
           class="row">
        <div class="col-sm-2">
          <label class="label"
                 for="livroAcervo">Acervo</label>
          <select id="livroAcervo"
                  v-model="localData.acervo"
                  v-validate="{ required: legado }"
                  :class="{'is-invalid' : errors.has('livroAcervo')}"
                  :disabled="localData.origem == 'novo'"
                  class="form-control form-control-sm"
                  name="livroAcervo"
                  placeholder="00"
                  @change="changed">
            <option :value="1">
              01
            </option>
            <option :value="2">
              02
            </option>
          </select>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label
              class="label"
              for="numLivro">Livro</label>
            <input
              id="numLivro"
              v-model="localData.numLivro"
              v-validate="{ required: legado }"
              class="form-control form-control-sm"
              :disabled="localData.origem == 'novo'"
              name="numLivro"
              :class="{'is-invalid' : errors.has('numLivro')}"
              placeholder="00000"
              type="number"
              @change="changed">
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label
              class="label"
              for="folha">Folha</label>
            <input
              id="folha"
              v-model="localData.folha"
              v-validate="{ required: legado }"
              class="form-control form-control-sm"
              :disabled="localData.origem == 'novo'"
              name="folha"
              :class="{'is-invalid' : errors.has('folha')}"
              placeholder="000"
              type="number"
              @change="changed">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label
              class="label"
              for="termo">Registro</label>
            <input
              id="termo"
              v-model="localData.termo"
              v-validate="{ required: legado }"
              class="form-control form-control-sm"
              :disabled="localData.origem == 'novo'"
              name="termo"
              :class="{'is-invalid' : errors.has('termo')}"
              placeholder="0000000"
              type="number"
              @change="changed">
          </div>
        </div>

        <div class="col-sm-2">
          <label class="label"
                 for="lado">Lado</label>
          <select id="lado"
                  v-model="localData.lado"
                  v-validate="{ required: legado }"
                  class="custom-select custom-select-sm"
                  name="lado"
                  :class="{'is-invalid' : errors.has('lado')}"
                  :disabled="localData.origem === 'novo'"
                  @change="changed">
            <option value=""
                    selected>
              Selecione
            </option>
            <option v-for="lado in lados"
                    :key="lado.key"
                    :value="lado.key">
              {{ lado.title }}
            </option>
          </select>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  /* services */
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* libraries */
  import { mapGetters } from 'vuex'
  import moment  from "moment"

  export default {
    name: 'PassoRegistro',
    props: ['data', 'legado'],
    inject: ['$validator'],
    data () {
      return {
        localData: {
          digitador: '',
          escrevente: '',
          origem: this.data.registro.origem,
          data_registro: new Date().toISOString().split('T')[0],
          termo: '',
          numLivro: '',
          folha: '',
          lado: '',
          cargo_escrevente: ''
        },
        tipo_registro: "O",
        limitdate: new Date().toISOString().split('T')[0],
        escreventes: [],
        digitadores: [],
        lados: [{title: "Frente", key: "FRENTE"}, {title: "Verso", key: "VERSO"}]
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      async data () {
        return this.localData = {...this.data.registro}
      },
    },
    async created () {
      this.localData = {
        digitador: this.user.nome,
        escrevente: this.user.escrevente ? this.user.nome : '',
        cargo_escrevente: this.user.escrevente ? this.user.cargo : '',
        data_registro: new Date().toISOString().split('T')[0],
        ...this.data.registro,
      }

      if (!this.localData.escrevente) {
        this.localData.escrevente = this.user.escrevente ? this.user.nome : ''
      }

      if (this.legado) {
        this.localData.origem = 'legado'
      } else {
        this.localData.origem = "novo"
      }

      this.changed()
      await this.loadUsers()
      document.querySelector('#falecido_digitador_nome').focus()
    },
    methods: {
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        if (this.data.registro.data_ocorrido) {
          return moment(this.data.registro.data_ocorrido).format("YYYY-MM-DD")
        }

        if (this.data.data_nascimento) {
          return moment(this.data.data_nascimento, 'DD/MM/YYYY').format("YYYY-MM-DD")
        }

        return moment('1500/01/01').format("YYYY-MM-DD")
      },

      reset () {
        this.localData.termo = ''
        this.localData.numLivro = ''
        this.localData.folha = ''
        this.localData.lado = ''
        this.localData.acervo = 1

        this.changed()
      },

      changed () {
        this.localData.tipo_registro = this.tipo_registro
        this.localData = { ...this.localData }
        this.$emit('registroUpdated', this.localData)
      },
      validateInputs (name) {
        this.$validator.validate(name)
        this.changed()
      },
      changeEscrevente () {
        if (this.localData.escrevente) {
          const selectEscreventes = document.getElementById('escrevente')
          this.localData.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex].cargo
        }
        this.changed()


      }
    }
  }
</script>

<style lang="scss">
  @import '../../../../scss/_utilities/exports';

  .passoRegistro {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>
